import React, { useEffect, useState } from 'react';
import { useComponents } from '@tencent/xj-components';
import { checkPcOrH5, formateImageWebp } from '../../utils';
import styles from './index.less';
var startX;
var startY;
var moveEndX;
var moveEndY;
var direction = '';
export var ImagePreviewModal = function (props) {
    var images = props.images, onHide = props.onHide, defaultIndex = props.defaultIndex;
    var _a = useComponents(), Modal = _a.Modal, Image = _a.Image, View = _a.View;
    var _b = useState(defaultIndex), currentIndex = _b[0], setCurrentIndex = _b[1];
    useEffect(function () {
        var handleDragStart = function (e) {
            e.stopPropagation();
            if (checkPcOrH5() === 'pc') {
                startX = e.screenX;
            }
        };
        var handleDragEnd = function (e) {
            e.stopPropagation();
            if (e.target.tagName !== 'IMG') {
                return;
            }
            if (checkPcOrH5() === 'pc') {
                moveEndX = e.screenX;
                var X = moveEndX - startX;
                if (X > 0) {
                    // 向右滑 →
                    setCurrentIndex(function (preIndex) { return (preIndex === 0 ? 0 : preIndex - 1); });
                }
                else if (X < 0) {
                    // 向左滑 ←
                    setCurrentIndex(function (preIndex) { return (preIndex === images.length - 1 ? 0 : preIndex + 1); });
                }
            }
        };
        window.addEventListener('dragstart', handleDragStart);
        window.addEventListener('dragend', handleDragEnd);
        return function () {
            window.removeEventListener('dragstart', handleDragStart);
            window.removeEventListener('dragend', handleDragEnd);
        };
    }, []);
    var handleTouchStart = function (e) {
        startX = e.x;
        startY = e.y;
    };
    var handleTouchMove = function (e) {
        moveEndX = e.x;
        moveEndY = e.y;
        var X = moveEndX - startX;
        var Y = moveEndY - startY;
        if (Math.abs(X) > Math.abs(Y) && X > 0) {
            // 向右滑 →
            direction = 'right';
        }
        else if (Math.abs(X) > Math.abs(Y) && X < 0) {
            // 向左滑 ←
            direction = 'left';
        }
        else {
            direction = '';
        }
    };
    var handleTouchEnd = function () {
        if (direction === 'left') {
            setCurrentIndex(function (preIndex) { return (preIndex === images.length - 1 ? 0 : preIndex + 1); });
        }
        else if (direction === 'right') {
            setCurrentIndex(function (preIndex) { return (preIndex === 0 ? 0 : preIndex - 1); });
        }
    };
    return (React.createElement(Modal, { show: true, position: "center", animationType: "slide-fade", mask: true, maskClosable: true, maskColor: "rgba(0,0,0,.45)", style: {
            width: '100%',
            maxWidth: '450px',
        }, className: styles['preview-image-wrapper'] },
        React.createElement(View, { className: styles['preview-image-close'], onClick: onHide }),
        React.createElement(View, { className: styles['preview-image'], onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd },
            React.createElement(Image, { style: { width: '100%' }, src: formateImageWebp(images[currentIndex]), imageWidth: 375, imageHeight: 263 })),
        React.createElement(View, { className: styles['preview-image-index-container'] },
            React.createElement(View, { className: styles['preview-image-current-index'] }, currentIndex + 1),
            "/ ",
            images.length)));
};
